import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import AddToWishlistNormalizer from "./AddToWishlistNormalizer";
export default class AddToWishlistNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new AddToWishlistNormalizer(),
        ];
    }
}
